import React from "react";
import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { useLang } from "../i18n/LangProvider";
import { POTENCE_HERO } from "../i18n/translations";

const Maintenance = ({ settings }) => {
  const { lang } = useLang();
  const message =
    lang === "fr"
      ? settings?.maintenance_message_fr
      : settings?.maintenance_message_en;

  return (
    <div
      data-testid="maintenance-page"
      className="relative min-h-screen bg-obsidian text-ivory flex items-center justify-center px-6 grain overflow-hidden"
    >
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src={POTENCE_HERO}
          alt="Grizzly"
          className="w-full h-full object-cover opacity-25"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-obsidian via-obsidian/85 to-obsidian/70" />
      </div>

      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, ease: "easeOut" }}
        className="relative z-10 max-w-xl text-center"
      >
        <h1 className="font-serif text-6xl sm:text-7xl font-light tracking-tight mb-3">
          Grizzly
        </h1>
        <p className="overline mb-10">La Potence · Le Grand-Saconnex</p>

        <p className="font-serif italic text-2xl sm:text-3xl text-ivory/85 leading-snug mb-10">
          {message}
        </p>

        <a
          href="tel:0227981011"
          data-testid="maintenance-call-button"
          className="btn-primary"
        >
          <Phone size={16} /> 022 798 10 11
        </a>
      </motion.div>
    </div>
  );
};

export default Maintenance;
